import { all } from 'redux-saga/effects';
import { currentUserRootSaga } from './user/sagas';
import { siteListSaga } from './siteList/sagas';
import { widgetSaga } from './widget/sagas';
import { issuesSaga } from './issues/sagas';
import { myReportsSaga } from './myReports/sagas';
import { dashboardsSaga } from './dashboards/sagas';
import { raisedByWidgetDashboardSaga } from './raisedByWidgetDashboard/sagas';
import { sitesDetailsSaga } from './sitesDetails/sagas';
import { automatedReportsSaga } from './automatedReports/sagas';
import { myReportsCountSaga } from './myReportsCount/sagas';
import { siteSaga } from './site/sagas';
import { paymentRootSaga } from './payment/sagas';
import { adminIssuesSaga } from './adminIssues/sagas';
import { siteUsersSaga } from './siteUsers/sagas';
import { issueSaga } from './issue/sagas';
import { adminSitesSaga } from './adminSites/sagas';
import { stopAuditSaga } from './stopAudit/sagas';
import { watchFetchSiteMap } from './sitemap/sagas';
import { watchOrganization } from './organization/sagas';
import { watchTools } from './tools/sagas';
import { watchDashboardCharts } from './dashboardCharts/sagas'


export default function* rootSaga(): Generator {
  yield all([
    currentUserRootSaga(),
    siteListSaga(),
    widgetSaga(),
    issuesSaga(),
    myReportsSaga(),
    dashboardsSaga(),
    raisedByWidgetDashboardSaga(),
    sitesDetailsSaga(),
    automatedReportsSaga(),
    siteSaga(),
    myReportsCountSaga(),
    paymentRootSaga(),
    adminIssuesSaga(),
    siteUsersSaga(),
    issueSaga(),
    adminSitesSaga(),
    stopAuditSaga(),
    watchFetchSiteMap(),
    watchOrganization(),
    watchTools(),
    watchDashboardCharts()
  ]);
}
